<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('login.login')" class="common-header">
        <!-- <mt-button slot="left" icon="back" @click="$router.go(-2)"></mt-button> -->
        <!-- <mt-button slot="right" @click="onSignup">{{ $t('register.register') }}</mt-button> -->
      </mt-header>
    </div>

    <!-- <div class="topList">
      <div class="list">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="item"
            v-on:click="onClickItem(index)"
        >
          <label
              class="title"
              v-bind:class="{active: index === currentIndex, normal: index !== currentIndex}"
          >
            {{ getTitle(item) }}
          </label> -->
          <!-- <div v-if="isShowLine(index)" class="line"></div> -->
        <!-- </div>
      </div>
    </div> -->
    <!-- login logo -->
    <div style="display: flex; justify-content: center; margin: 60px 0px 25px;">
      <img src="@/assets/image/login_logo.svg" style="width: 50%" />
    </div>

    <login-by-mobile @getLoginState="state => this.loginState = state"></login-by-mobile>

    <div class="mt-10 forgot-password">
      <label id="retrieve-title" @click="onRetrieve">{{ $t('login.forgot_password') }}?</label>
    </div>
    <div class="forgot-password" style="margin-top: 5px">
      <label id="retrieve-title" @click="onSignup">{{ $t('register.register') }}</label>
    </div>
    <div class="mt-20 center">
      <label class="visitor" @click="$router.push({ name: 'HomeIndex' })">{{ $t('login.visitor') }}</label>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapMutations, mapState } from 'vuex'
import LoginByMobile from './LoginByMobile'

export default {
  name: 'Login',
  components: {
    LoginByMobile
  },
  data () {
    return {
      currentIndex: 0,
      loginState: false,
      items: [
        {
          id: 1,
          title: this.$t('login.login_by_mobile')
        }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.utils.setCookie('referrer', encodeURIComponent(from.fullPath), 1 / 24)
    })
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId,
      config: state => state.config.config
    })
  },
  watch: {
    loginState: function (val) {
      if (val) {
        this.goHome()
      }
    }
  },
  created: function () {
    if (this.$route.query.clear) {
      this.memberLogout()
    }
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin',
      saveSellerAuthInfo: 'sellerLogin',
      memberLogout: 'memberLogout'
    }),
    getTitle (item) {
      return item ? item.title : ''
    },
    isShowLine (index) {
      return index === this.currentIndex
    },
    onClickItem (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index
      }
    },

    goBack () {
      let isFromInfoEdit = this.$route.params.isFromInfoEdit
      let isFromShare = this.$route.params.isFromShare
      if (isFromInfoEdit || isFromShare) {
        this.$router.push('home')
      } else {
        this.$router.go((this.$route.query.clear) ? -2 : -1)
      }
    },

    goHome () {
      this.$router.push({name: 'HomeIndex'});
    },
    getReferrer () {
      let referrer = this.$route.query.referrer
      if (!referrer) {
        referrer = this.utils.getCookie('referrer')
      }
      if (referrer && (referrer.search('memberlogin') !== -1 || referrer.search('memberregister') !== -1 || referrer.search('memberbind') !== -1)) {
        referrer = '/member/index'
      }
      return referrer
    },

    onSignup () {
      this.$router.push({ name: 'HomeMemberRegister' })
    },

    onRetrieve () {
      this.$router.push({ name: 'HomeMemberForget' })
    }
  }
}
</script>

<style lang='scss' scoped>
.container {

  .countdown {
    min-width: 4rem;
    margin-right: 0.5rem;
  }

  .top-wrapper {
    .input-wrapper {
      display: flex;
      align-content: center;
      align-items: center;
      padding-left: 0.4rem;
      background-color: #fff;
      height: 2.2rem;

      img {
        height: 1.75rem;
        width: auto;
        margin: 0;
        padding: 0;
      }

      input {
        flex: 1;
        font-size: .8rem;
      }

      .bottom-input {
        border-bottom-width: 0;
      }
    }
  }
}
.common-header {
  height: 4rem;
  line-height: 4rem;
  border-radius: 0px 0px 30px 30px;
  background: #f4c41e;
}
.forgot-password, .center {
  text-align: center;
}
.visitor {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
}
#retrieve-title {
  color: #DD2C35;
  // color: $primaryColor;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.topList {
  height: 2rem;
  padding-top: 2rem;
  border-bottom: 1px solid #e8eaed;

  .list {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    align-items: stretch;
    background-color: #f5f5f5;
  }

  .item {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .title {
    text-align: center;
    font-size: 0.7rem;
    color: #404245;
  }

  .active {
    // color: $primaryColor;
    color: black
  }

  .normal {
    color: #404245;
  }

  .line {
    position: absolute;
    left: 2.5rem;
    right: 2.5rem;
    bottom: 0;
    height: 0.1rem;
    background-color: #fa800a;
  }
}

</style>
